import { useTheme } from "../ThemeProvider/ThemeContext.mjs";
const useColor = () => useTheme().color;
export {
  useColor
};
